import React from 'react';
import CouponList from '../../../components/CouponList/CouponList';

export default ({ redeemingChannel, items }) => (
    <CouponList redeemingChannel={redeemingChannel} coupons={items} />
);
